var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"restaurant-name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"restaurant-address"},[_vm._v(_vm._s(_vm.address))])])}
var staticRenderFns = []

export { render, staticRenderFns }